import { type ReducersMapObject } from "@reduxjs/toolkit";
import { reducer as core, type State as CoreState } from "@vana/core";
import { reducer as home, type State as HomeState } from "@vana/home";
import { reducer as allDeliveries } from "../features/all-deliveries/redux/reducer";
import { type State as AllDeliveriesState } from "../features/all-deliveries/redux/state";
import { reducer as batches } from "../features/batches/redux/reducer";
import { type State as BatchesState } from "../features/batches/redux/state";
import { reducer as compliance } from "../features/compliance/redux/reducer";
import { type State as ComplianceState } from "../features/compliance/redux/state";
import { reducer as dayClose } from "../features/day-close/redux/reducer";
import { type State as DayCloseState } from "../features/day-close/redux/state";
import { reducer as deliveries } from "../features/deliveries/redux/reducer";
import { type State as DeliveriesState } from "../features/deliveries/redux/state";
import { reducer as education } from "../features/education/redux/reducer";
import { type State as EducationState } from "../features/education/redux/state";
import { reducer as failedDelivery } from "../features/failed-delivery/redux/reducer";
import { type State as FailedDeliveryState } from "../features/failed-delivery/redux/state";
import { reducer as firstPurchase } from "../features/first-purchase/redux/reducer";
import { type State as FirstPurchaseState } from "../features/first-purchase/redux/state";
import { reducer as kyc } from "../features/kyc/redux/reducer";
import { type State as KycState } from "../features/kyc/redux/state";
import { reducer as problemReport } from "../features/problem-report/redux/reducer";
import { type State as ProblemReportState } from "../features/problem-report/redux/state";
import { reducer as referralsBackoffice } from "../features/referrals-backoffice/redux/reducer";
import { type State as ReferralsBackofficeState } from "../features/referrals-backoffice/redux/state";
import { reducer as referrals } from "../features/referrals/redux/reducer";
import { type State as ReferralsState } from "../features/referrals/redux/state";
import { reducer as reports } from "../features/reports/redux/reducer";
import { type State as ReportsState } from "../features/reports/redux/state";
import { reducer as summary } from "../features/summary/redux/reducer";
import { type State as SummaryState } from "../features/summary/redux/state";
import { reducer as team } from "../features/team/redux/reducer";
import { type State as TeamState } from "../features/team/redux/state";
import { reducer as reschedules } from "../features/reschedules/redux/reducer";
import { type State as ReschedulesState } from "../features/reschedules/redux/state";
import { reducer as pendingConfirmation } from "../features/pending-confirmation/redux/reducer";
import { reducer as undelivered } from "../features/undelivered/redux/reducer";
import { type State as PendingConfirmationState } from "../features/pending-confirmation/redux/state";
import { reducer as supervisorDelivery } from "../features/supervisor-delivery/redux/reducer";
import { type State as SupervisorDeliveryState } from "../features/supervisor-delivery/redux/state";
import { reducer as routeAssignment } from "../features/route-assignment/redux/reducer";
import { type State as RouteAssignmentState } from "../features/route-assignment/redux/state";
import { reducer as users } from "../features/users/redux/reducer";
import { type State as UsersState } from "../features/users/redux/state";
import { reducer as zones } from "../features/zones/redux/reducer";
import { type State as ZonesState } from "../features/zones/redux/state";

export type State = CoreState &
  HomeState &
  DeliveriesState &
  KycState &
  EducationState &
  FirstPurchaseState &
  ReferralsState &
  ReferralsBackofficeState &
  FailedDeliveryState &
  ProblemReportState &
  DayCloseState &
  RouteAssignmentState &
  UsersState &
  ZonesState &
  ReportsState &
  SummaryState &
  TeamState &
  SupervisorDeliveryState &
  ReschedulesState &
  PendingConfirmationState &
  AllDeliveriesState &
  BatchesState &
  ComplianceState;

export const reducer: ReducersMapObject<State> = {
  ...core,
  ...home,
  ...deliveries,
  ...kyc,
  ...education,
  ...firstPurchase,
  ...referrals,
  ...referralsBackoffice,
  ...failedDelivery,
  ...problemReport,
  ...dayClose,
  ...routeAssignment,
  ...users,
  ...zones,
  ...reports,
  ...summary,
  ...team,
  ...supervisorDelivery,
  ...reschedules,
  ...pendingConfirmation,
  ...undelivered,
  ...allDeliveries,
  ...batches,
  ...compliance,
};
